const testUser = {
  id: 42,
  firstName: 'Sasha',
  lastName: 'NewClient',
  lookerGroupIds: [9],
  groupName: 'ClientCompany'
};

export default testUser;
